
















import Vue from "vue"

export default Vue.extend({
  props: {
    linkUrl: {
      type: String,
      required: true,
    },
    backgroundImageUrl: {
      type: String,
      required: true,
    },
  },
})
